import { ICustomerModel } from 'entities/Customer/Customer.models';

export const getCustomerFullName = (customer?: ICustomerModel | null): string => {
  const { firstName, lastName } = customer || {};
  return firstName && lastName ? `${firstName} ${lastName}` : firstName ? firstName : lastName ? lastName : 'Unknown name';
};
